import MenuLink from "./MenuLink";
import { useTranslation } from "react-i18next";

const MasteryLink = () => {
  const { t } = useTranslation();
  return <MenuLink caption={t("nav.mastery")} to={"/mastery"} />;
};

export default MasteryLink;
